/**
* @ngdoc object
* @name common.constant:DUTTI_CONS
*
* @description
* Dutti constants
*/
(function(itxApp) {
    'use strict';
    /** Public */

    var obj = {
        languages: {
            'EN': -1, //inglés
            'FR': -2, // francés
            'DE': -3, // alemán
            'IT': -4, // italiano
            'ES': -5, // cast
            'PT': -6, // portugués
            'ZH': -7, // chino simplificado
            'ZT': -8, // chino tradicional
            'KO': -9, // coreano
            'EU': -11, // Euskera
            'GA': -12, // Gallego
            'CA': -13, // Catalán
            'EL': -14, // Griego
            'RU': -20, // ruso
            'RO': -21, // rumano
            'PL': -22, // polaco
            'CS': -27, // checo
            'SK': -28, // eslovaco
            'BG': -30, // búlgaro
            'LT': -33, // Lituano LT
            'ET': -34, // Estonio ET
            'LV': -35, // Letón LV
            'HR': -38, // croata
            'DA': -39, // danés
            'NO': -40, // noruego
            'TR': -43, // Turco
            'AR': -44, // Árabe AR
            'NL': 100, // Holandés
            'SL': -36, // Esloveno
            'NL-BE': -26, // flamenco
            'ES-MX': -50, // Mexicano
            'EN-US': -15, // Inglés de USA
            'FR-CA': -32, // Francés de CANADÁ
            'UK': -47, // ukraniano,
            'SR': -53, // Serbio
            'IN': -49, // Indonesio
            'IW': -52, // Hebreo
            'TH': -37, // Tailandés
            'VI': -54, // Vietnamita
            'SQ': -55, // Albanés
            'MK': -56, // Macedonio
            'KA': -61 // Georgiano
        },
        stores: {
            //VENTA
            'DuttiST': 33009450, //- DuttiNEWStorefrontAssetStore (Tienda Genérica)
            'DuttiES': 34009450, //- España (ES, EN, EU, GL, CA) 2
            'DuttiIC': 34009463, // Islas Canarias (ES, EN)
            'DuttiPT': 34009460, // Portugal (PT, EN)
            'DuttiNL': 34009453, // NETHERLAND (EN, NL)
            'DuttiIE': 34009457, // Ireland (EN)
            'DuttiGB': 34009456, // United kingdom (EN)
            'DuttiSE': 34009462, // Sweden (Suecia) (EN)
            'DuttiNO': 34009477, // Norway Noruega (EN, NO)
            'DuttiCH': 34009476, // Switzerland (Suiza) (EN,FR,DE,IT)
            'DuttiDK': 34009458, // Dinamarca (EN, DA)
            'DuttiPL': 35009474, // Polonia (PL e EN)
            'DuttiDE': 34009454, // Alemania (DE, EN)
            'DuttiAT': 34009469, // Austria (DE, EN)
            'DuttiIT': 34009455, // Italia (IT, EN)
            'DuttiFR': 34009451, // Francia (FR, EN)
            'DuttiBE': 34009452, // Belgium (FR, EN, DE, NLB)
            'DuttiLU': 34009461, // luxemburgo (FR, EN)
            'DuttiMC': 34009467, // MONACO (FR, EN)
            'DuttiRO': 35009473, // RUMANIA (RO, EN)
            'DuttiGR': 34009459, // Grecia (EN, EL)
            'DuttiRU': 35009472, // Rusia (EN, RU)
            'DuttiMX': 35009470, // México (ES//MX, EN)
            'DuttiCA': 35009528, // Canadá (EN, FR)
            'DuttiUS': 34009527, // USA (ES, EN)
            'DuttiCZ': 35009509, // REPÚBLICA CHECA (EN, CZ)
            'DuttiCN': 35009478, // CHINA (EN, ZH)
            'DuttiKR': 35009516, // KOREA (EN, KO)
            'DuttiHR': 35009475, // CROACIA (EN, HR)
            'DuttiSK': 35009495, // ESLOVAQUIA (EN, SK)
            'DuttiBG': 35009493, // BULGARIA (EN, BG)
            'DuttiSI': 35009496, // ESLOVENIA (EN,EE) ????
            'DuttiFI': 34009536, // FINLANDIA (EN)
            'DuttiHU': 35009501, // HUNGRÍA (EN)
            'DuttiEE': 35009497, // ESTONIA (EN, RU, ET)
            'DuttiLT': 35009505, // LITUANIA (EN, RU, LT)
            'DuttiLV': 35009504, // LETONIA (EN, RU, LV)
            'DuttiTR': 34009471, // TURQUÍA (EN, TR)
            'DuttiCY': 35009484, // CHIPRE (EN)
            'DuttiMT': 35009489, // MALTA (EN) 2,
            'DuttiWW': 38009450, // MALTA (EN) 2
            'DuttiWY': 38009451,
            'DuttiWZ': 38009452,
            'DuttiWA': 38009453,
            'DuttiWE': 38009454,
            'DuttiMA': 35009486,
            'DuttiSA': 35009480,
            'DuttiAE': 35009481,
            'DuttiKW': 35009482,
            'DuttiBH': 35009487,
            'DuttiJO': 35009488,
            'DuttiQA': 35009490,
            'DuttiEG': 35009491,
            'DuttiLB': 34009483,
            'DuttiHK': 35009499,
            'DuttiIN': 35010114,
            'DuttiDZ': 34009539,
            //NO VENTA
            'DuttiCR': 35009522,
            'DuttiAD': 35009485,
            'DuttiGT': 35009498,
            'DuttiID': 35009500,
            'DuttiKZ': 35009503,
            'DuttiMO': 35009506,
            'DuttiMY': 35009507,
            'DuttiRS': 35009510,
            'DuttiSG': 35009511,
            'DuttiSY': 35009512,
            'DuttiUA': 35009513,
            'DuttiCO': 35009515,
            'DuttiTH': 35009518,
            'DuttiIL': 35009519,
            'DuttiILAUX': 36009519,
            'DuttiPH': 35009521,
            'DuttiGE': 35009523,
            'DuttiDO': 35009517,
            'DuttiMK': 35009529,
            'DuttiPR': 35009531,
            'DuttiTW': 35009532,
            'DuttiAM': 35009530,
            'DuttiPA': 35009533,
            'DuttiAZ': 35009526,
            'DuttiHN': 35009534,
            'DuttiEC': 35009524,
            'DuttiAL': 35009538,
            'DuttiBA': 35009525,
            'DuttiTN': 35009537,
            'DuttiBY': 35009541,
            'DuttiVN': 35000140,
            'DuttiXK': 35009545,
            
        },
        langNoGeneric: {
            'DE': -3, // alemán
            'ZH': -7, // chino
            'KO': -9, // coreano
            'EU': -11, // Euskera
            'EL': -14, // Griego
            'TR': -43, // Turco
            'RU': -20, // ruso
            'AR': -44, // Árabe AR
            'NL': 100, // Holandés
        }
    };
    obj.country={
        //VENTA
        'AL': 35009538,
        'ST': 33009450, //- DuttiNEWStorefrontAssetStore (Tienda Genérica)
        'ES': 34009450, //- España (ES, EN, EU, GL, CA) 2
        'IC': 34009463, // Islas Canarias (ES, EN)
        'PT': 34009460, // Portugal (PT, EN)
        'NL': 34009453, // NETHERLAND (EN, NL)
        'IE': 34009457, // Ireland (EN)
        'GB': 34009456, // United kingdom (EN)
        'SE': 34009462, // Sweden (Suecia) (EN)
        'NO': 34009477, // Norway Noruega (EN, NO)
        'CH': 34009476, // Switzerland (Suiza) (EN,FR,DE,IT)
        'DK': 34009458, // Dinamarca (EN, DA)
        'PL': 35009474, // Polonia (PL e EN)
        'DE': 34009454, // Alemania (DE, EN)
        'AT': 34009469, // Austria (DE, EN)
        'IT': 34009455, // Italia (IT, EN)
        'FR': 34009451, // Francia (FR, EN)
        'BE': 34009452, // Belgium (FR, EN, DE, NLB)
        'LU': 34009461, // luxemburgo (FR, EN)
        'MC': 34009467, // MONACO (FR, EN)
        'RO': 35009473, // RUMANIA (RO, EN)
        'GR': 34009459, // Grecia (EN, EL)
        'RU': 35009472, // Rusia (EN, RU)
        'MX': 35009470, // México (ES//MX, EN)
        'CA': 35009528, // Canadá (EN, FR)
        'US': 34009527, // USA (ES, EN)
        'CZ': 35009509, // REPÚBLICA CHECA (EN, CZ)
        'CN': 35009478, // CHINA (EN, ZH)
        'KR': 35009516, // KOREA (EN, KO)
        'HR': 35009475, // CROACIA (EN, HR)
        'SK': 35009495, // ESLOVAQUIA (EN, SK)
        'BG': 35009493, // BULGARIA (EN, BG)
        'SI': 35009496, // ESLOVENIA (EN,EE) ????
        'FI': 34009536, // FINLANDIA (EN)
        'HU': 35009501, // HUNGRÍA (EN)
        'EE': 35009497, // ESTONIA (EN, RU, ET)
        'LT': 35009505, // LITUANIA (EN, RU, LT)
        'LV': 35009504, // LETONIA (EN, RU, LV)
        'TR': 34009471, // TURQUÍA (EN, TR)
        'CY': 35009484, // CHIPRE (EN)
        'MT': 35009489, // MALTA (EN) 2
        'MA': 35009486,
        'GE': 35009523,
        'HK': 35009499,
        'IN': 35010114,
        'DZ': 34009539, // ARGELIA
        //NO VENTA
        'CR': 35009522,
        'SA': 35009480,
        'AE': 35009481,
        'KW': 35009482,
        'AD': 35009485,
        'BH': 35009487,
        'JO': 35009488,
        'QA': 35009490,
        'EG': 35009491,
        'GT': 35009498,
        'ID': 35009500,
        'KZ': 35009503,
        'MO': 35009506,
        'MY': 35009507,
        'RS': 35009510,
        'SG': 35009511,
        'SY': 35009512,
        'UA': 35009513,
        'CO': 35009515,
        'TH': 35009518,
        'IL': 35009519,
        'II': 36009519,
        'PH': 35009521,
        'DO': 35009517,
        'MK': 35009529,
        'PR': 35009531,
        'TW': 35009532,
        'AM': 35009530,
        'PA': 35009533,
        'AZ': 35009526,
        'HN': 35009534,
        'EC': 35009524,
        'BA': 35009525,
        'TN': 35009537,
        'LB': 34009483,
        'BY': 35009541,
        'VN': 35000140,
        'XK': 35009545,
        'WW': 38009450,
        'WY': 38009451,
        'WZ': 38009452,
        'WA': 38009453,
        'WE': 38009454,
    };
    
    obj.i_stores = _.invert(obj.stores);
    obj.i_languages = _.invert(obj.languages);
    obj.i_country = _.invert(obj.country);
    obj.i_langNoGeneric = _.invert(obj.langNoGeneric);
    
    obj.NO_VENTA = [
        'DuttiTH', 
        'DuttiCR', 
        'DuttiTK', 
        'DuttiAD', 
        'DuttiGT', 
        'DuttiMO', 
        'DuttiRS', 
        'DuttiSY', 
        'DuttiUA', 
        'DuttiCO', 
        'DuttiIL', 
        'DuttiPH', 
        'DuttiDO', 
        'DuttiPR', 
        'DuttiTW', 
        'DuttiAM', 
        'DuttiPA', 
        'DuttiAZ', 
        'DuttiHN', 
        'DuttiEC', 
        'DuttiBA',
        'DuttiBY', 
        'DuttiXK'
    ];

    obj.COOKIE_GROUPS = {
        TECHNICAL: 'C0001',
        ANALYTICS: 'C0002',
        FUNCTIONAL_PERSONALIZATION: 'C0003',
        BEHAVIOURAL_ADVERTISING: 'C0004',
        SOCIAL_MEDIA: 'C0005',
    }

    var CD_EUROPA = 1,
        CD_CHINA = 2,
        CD_COREA = 2,
        CD_MEXICO = 3,
        CD_POLONIA = 4,
        CD_REINO_UNIDO = 2,
        D_RUSIA = 3,
        CD_TURQUIA = 4,
        CD_USA = 2;
    // jshint ignore:end

    angular.module('itxApp.preCommon').constant('DUTTI_CONS', obj);

})();